import script from "./AppContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./AppContainer.vue?vue&type=script&setup=true&lang=js"

import "./AppContainer.vue?vue&type=style&index=0&id=483322ba&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-483322ba"]])

export default __exports__